import { render, staticRenderFns } from "./BackboneContainer.vue?vue&type=template&id=15eb7b4e"
import script from "./BackboneContainer.vue?vue&type=script&lang=js"
export * from "./BackboneContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports